import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, SearchIcon, FilterIcon } from 'lucide-react';
import ProjectCard from './common/ProjectCard';
import { mockProjects } from '../data/mockData';
import Button from './common/Button';
const ProjectList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('All');
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'
  const filteredProjects = mockProjects.filter(project => {
    const matchesSearch = project.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterStatus === 'All' || project.status === filterStatus;
    return matchesSearch && matchesFilter;
  });
  // Define status color based on project status
  const getStatusColor = status => {
    switch (status) {
      case 'Planning':
        return 'bg-blue-100 text-blue-800';
      case 'In Progress':
        return 'bg-green-100 text-green-800';
      case 'At Risk':
        return 'bg-yellow-100 text-yellow-800';
      case 'On Hold':
        return 'bg-gray-100 text-gray-800';
      case 'Completed':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div data-id="element-1626">
      <div className="flex justify-between items-center mb-6" data-id="element-1627">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1628">
          Construction Projects
        </h1>
        <Button data-id="element-1629">
          <PlusIcon className="w-5 h-5 mr-2" data-id="element-1630" />
          Add Project
        </Button>
      </div>
      {/* Search and Filter */}
      <div className="flex flex-col md:flex-row gap-4 mb-6" data-id="element-1631">
        <div className="relative flex-grow" data-id="element-1632">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1633">
            <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-1634" />
          </div>
          <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500" placeholder="Search projects..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1635" />
        </div>
        <div className="relative w-full md:w-48" data-id="element-1636">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1637">
            <FilterIcon className="h-5 w-5 text-gray-400" data-id="element-1638" />
          </div>
          <select className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" value={filterStatus} onChange={e => setFilterStatus(e.target.value)} data-id="element-1639">
            <option value="All" data-id="element-1640">All Status</option>
            <option value="Planning" data-id="element-1641">Planning</option>
            <option value="In Progress" data-id="element-1642">In Progress</option>
            <option value="At Risk" data-id="element-1643">At Risk</option>
            <option value="On Hold" data-id="element-1644">On Hold</option>
            <option value="Completed" data-id="element-1645">Completed</option>
          </select>
        </div>
      </div>
      {/* View mode toggle */}
      <div className="flex justify-between items-center mb-4" data-id="element-1646">
        <div className="text-sm text-gray-500" data-id="element-1647">
          {filteredProjects.length} projects
        </div>
        <div className="flex gap-2" data-id="element-1648">
          <button className={`p-1.5 rounded ${viewMode === 'grid' ? 'bg-gray-100 text-gray-800' : 'text-gray-500 hover:bg-gray-50'}`} onClick={() => setViewMode('grid')} data-id="element-1649">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1650">
              <rect x="3" y="3" width="7" height="7" data-id="element-1651" />
              <rect x="14" y="3" width="7" height="7" data-id="element-1652" />
              <rect x="14" y="14" width="7" height="7" data-id="element-1653" />
              <rect x="3" y="14" width="7" height="7" data-id="element-1654" />
            </svg>
          </button>
          <button className={`p-1.5 rounded ${viewMode === 'list' ? 'bg-gray-100 text-gray-800' : 'text-gray-500 hover:bg-gray-50'}`} onClick={() => setViewMode('list')} data-id="element-1655">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1656">
              <line x1="8" y1="6" x2="21" y2="6" data-id="element-1657" />
              <line x1="8" y1="12" x2="21" y2="12" data-id="element-1658" />
              <line x1="8" y1="18" x2="21" y2="18" data-id="element-1659" />
              <line x1="3" y1="6" x2="3.01" y2="6" data-id="element-1660" />
              <line x1="3" y1="12" x2="3.01" y2="12" data-id="element-1661" />
              <line x1="3" y1="18" x2="3.01" y2="18" data-id="element-1662" />
            </svg>
          </button>
        </div>
      </div>
      {/* Projects Grid or List */}
      {filteredProjects.length > 0 ? viewMode === 'grid' ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1663">
            {filteredProjects.map(project => <ProjectCard key={project.id} project={project} data-id="element-1664" />)}
          </div> : <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1665">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-1666">
              <thead className="bg-gray-50" data-id="element-1667">
                <tr data-id="element-1668">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1669">
                    Project Name
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1670">
                    Property
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1671">
                    Timeline
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1672">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1673">
                    Progress
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1674">
                {filteredProjects.map(project => {
            const property = mockProjects.find(p => p.id === project.propertyId);
            const progressPercentage = Math.round(project.completedTasks / project.totalTasks * 100);
            return <tr key={project.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => window.location.href = `/projects/${project.id}`} data-id="element-1675">
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1676">
                        <div className="flex items-center" data-id="element-1677">
                          <div data-id="element-1678">
                            <div className="text-sm font-medium text-gray-900" data-id="element-1679">
                              {project.name}
                            </div>
                            <div className="text-sm text-gray-500 truncate max-w-xs" data-id="element-1680">
                              {project.description}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1681">
                        <div className="text-sm text-gray-900" data-id="element-1682">
                          {property?.name || 'N/A'}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1683">
                        <div className="text-sm text-gray-900" data-id="element-1684">
                          {project.startDate} to {project.endDate}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1685">
                        <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(project.status)}`} data-id="element-1686">
                          {project.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1687">
                        <div className="flex items-center" data-id="element-1688">
                          <div className="w-full bg-gray-200 rounded-full h-1.5 mr-2 max-w-[100px]" data-id="element-1689">
                            <div className={`h-1.5 rounded-full ${project.status === 'At Risk' ? 'bg-yellow-500' : 'bg-blue-600'}`} style={{
                      width: `${progressPercentage}%`
                    }} data-id="element-1690"></div>
                          </div>
                          <span className="text-sm text-gray-500" data-id="element-1691">
                            {progressPercentage}%
                          </span>
                        </div>
                      </td>
                    </tr>;
          })}
              </tbody>
            </table>
          </div> : <div className="text-center py-12" data-id="element-1692">
          <p className="text-gray-500" data-id="element-1693">
            No projects found matching your criteria.
          </p>
        </div>}
    </div>;
};
export default ProjectList;